export interface ConnectionRoutingSettings {
    connection_spacing: number
}

export const DEFAULT_CONNECTION_ROUTING_SETTINGS: Readonly<ConnectionRoutingSettings> = Object.freeze({
    connection_spacing: 12,
})

export function normalizeConnectionSpacing(value: unknown): number {
    const spacing = Number(value)
    return Number.isFinite(spacing) && spacing > 0
        ? spacing
        : DEFAULT_CONNECTION_ROUTING_SETTINGS.connection_spacing
}

export function connectionRoutingSettings(source?: any): ConnectionRoutingSettings {
    return {
        connection_spacing: normalizeConnectionSpacing(
            source?.connection_spacing ?? source?.getAttr?.('connection_spacing'),
        ),
    }
}

export function restoreDesignerPageRoutingSettings(layer: any, pageRecord: any): number | null {
    if (pageRecord?.connection_spacing === undefined) return null
    const spacing = normalizeConnectionSpacing(pageRecord.connection_spacing)
    if (layer?.setAttr) layer.setAttr('connection_spacing', spacing)
    else if (layer) layer.connection_spacing = spacing
    return spacing
}
